var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.config.ui_version==3.7)?_c('sidebar3Dian7',{attrs:{"showPopup":_vm.showPopup}}):_c('sidebar',{attrs:{"showPopup":_vm.showPopup}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }